"use client";

import { useTheme } from "next-themes";
import { useState, useEffect } from "react";

/**
 * Centralizes the common mounted-guard + resolved theme pattern from next-themes.
 * Replaces the duplicated mounted/theme detection logic across header, nav,
 * theme-toggle, and parallax-visuals components.
 */
export function useResolvedTheme() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return {
    mounted,
    theme: mounted ? resolvedTheme : undefined,
    isLight: mounted && resolvedTheme === "light",
    isDark: mounted && resolvedTheme === "dark",
    setTheme,
  };
}
